












































import { Component, Vue, Watch } from 'vue-property-decorator';
import authProvider from '@/utility/authProvider';
import { APP_CONFIG } from '@/config/app-config';

import Notification from './Notification.vue';

@Component({
    components: {
        'notification': Notification
    }
})
export default class AppHeader extends Vue {
    private isOpenMenuUser = false;
    private totalNotify = 0;

    @Watch('userInfo', { immediate: true, deep: true })
    private async watchUserInfo() {
        if (this.userInfo) {
            this.$cookies.set('vtb_user',this.userInfo.userName, -1, '', this.isDepositSystem ? 'songphuongtrade.vn' : 'songphuongtrade.vn'); 
        }
    }

    get isDepositSystem() {
        return APP_CONFIG.system_type !== 'order';
    }

    get main_domain() {
        return APP_CONFIG.system_type !== 'order' ? APP_CONFIG.settings.main_domain_deposit : APP_CONFIG.settings.main_domain;
    }

    get showMenuLeft() {
        return this.$store.state[APP_CONFIG.stateKey.commonStore].showMenuLeft;
    }

    get userInfo() {
        return this.$store.state[APP_CONFIG.stateKey.authStore].userInfo;
    }

    get customerInfo() {
        return this.$store.state[APP_CONFIG.stateKey.authStore].customerInfo;
    }

    get isToken() {
        return authProvider.isToken();
    }

    private onOpenUserMenu() {
        this.isOpenMenuUser = !this.isOpenMenuUser;
    }

    private onLogout() {
        this.$cookies.remove('vtb_user'); 
        (window['getApp'] as any).$emit('APP_LOGOUT');
    }

    private onToggleMenu() {
        (window['getApp'] as any).$emit('SHOW_HIDE_MENU_LEFT', !this.showMenuLeft);
    }

    private getTotalNotification(total: number) {
        this.totalNotify = total;
    }
}
